import { formatNumberPersian } from './mobileUtils';

export const formatPrice = (price) => {
  if (price === null || price === undefined || price === '') return '';
  const formatted = new Intl.NumberFormat('fa-IR').format(price);
  return formatNumberPersian(formatted) + ' ریال';
};
